import { fetchToken } from "../../common/FetchCookie";
import { BASE_URL, COMPANY_LIST, PUBLIC } from "../../common/URLs";

export const fetchCompanyList = async (page) => {
  const url = `${BASE_URL}/${PUBLIC}/${COMPANY_LIST}?page=${page}`; // Proxy path
  try {
    const token = await fetchToken()

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `${token}`,
      },
    });
    // console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    return error
  }
};

// export const fetchJobListByCompany = async (uuid) => {
//     const url = `https://api.indiahirings.com/api/fetch-company-job-list/${uuid}`; // Proxy path
//     try {
//       const response = await fetch(url, {
//         method: "GET",
//         headers: {
//           Accept: "application/json",
//           // Authorization: `Bearer 141|7jLKxBgRj3GaHg0cOlq9H3TXReLw4rdqByNQfELqe933dae8`,
//         },
//       });
//       console.log("response", response)
//       const data = await response.json();
//       return data;
//     } catch (error) {
//       console.log("error", error);
//     }
//   };

// export const fetchCompanyProfile = async (uuid) => {
//     const url = `https://api.indiahirings.com/api/fetch-company-details/${uuid}`; // Proxy path
//     try {
//       const response = await fetch(url, {
//         method: "GET",
//         headers: {
//           Accept: "application/json",
//           // Authorization: `${AUTH}`,
//         },
//       });
//       // console.log("response", response)
//       const data = await response.json();
//       return data;
//     } catch (error) {
//       console.log("error", error);
//     }
//   };